import React from "react";
import { Link } from "react-router-dom";
import {
    Collapse,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from "@mui/material";

import ThisTheme from "../../../themes/TMSTheme";

import EventIcon from "@mui/icons-material/Event";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SchoolIcon from "@mui/icons-material/School";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

const TMSMenu = () => {
    const [open, setOpen] = React.useState(false);
    const handleClick = () => {
        setOpen(!open);
    };

    const menuItems = [
        {
            path: "/tms/",
            label: "My Training",
            icon: (
                <DashboardIcon sx={{ color: ThisTheme.palette.primary.main }} />
            ),
        },
        {
            path: "/tms/enrolments",
            label: "Enrolments",
            icon: <SchoolIcon sx={{ color: ThisTheme.palette.primary.main }} />,
        },
        {
            path: "/tms/library",
            label: "Library",
            icon: (
                <LocalLibraryIcon
                    sx={{ color: ThisTheme.palette.primary.main }}
                />
            ),
        },
        {
            path: "/tms/events",
            label: "Events",
            icon: <EventIcon sx={{ color: ThisTheme.palette.primary.main }} />,
        },

        {
            path: "/tms/accomplishments",
            label: "Accomplishments",
            icon: (
                <EmojiEventsIcon
                    sx={{ color: ThisTheme.palette.primary.main }}
                />
            ),
        },
    ];

    return (
        <List
            component="nav"
            className="menu-list"
            aria-label="Training menu"
            data-cy="menu_tms"
        >
            <ListItem
                component="div"
                onClick={handleClick}
                aria-expanded={open}
                disablePadding
            >
                <ListItemButton>
                    <ListItemIcon>
                        <SchoolOutlinedIcon
                            sx={{ color: ThisTheme.palette.primary.main }}
                        />
                    </ListItemIcon>
                    <ListItemText primary="Training" />
                    {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </ListItemButton>
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="nav" disablePadding>
                    {menuItems.map(({ path, icon, label }) => (
                        <ListItem
                            key={path}
                            component={Link}
                            to={path}
                            disablePadding
                        >
                            <ListItemButton className="nested">
                                <ListItemIcon>{icon}</ListItemIcon>
                                <ListItemText>{label}</ListItemText>
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Collapse>
        </List>
    );
};

export default TMSMenu;
